type PaymentBrandIconProps = {
  brand: string;
  size?: 'sm' | 'md';
};

export function PaymentBrandIcon({ brand, size = 'md' }: PaymentBrandIconProps) {
  const b = brand.toUpperCase();
  const container = size === 'sm'
    ? 'flex h-9 w-12 flex-shrink-0 items-center justify-center rounded-lg'
    : 'flex h-10 w-14 flex-shrink-0 items-center justify-center rounded-lg';

  if (b === 'VISA') {
    return (
      <div className={`${container} bg-blue-600`}>
        <svg viewBox="0 0 80 26" className="h-4 w-auto" fill="white">
          <path d="M30.6 0.8L19.9 25.2H12.8L7.5 6.3C7.2 5.1 6.9 4.7 6 4.2 4.5 3.4 2 2.6 0 2.1L0.2 0.8H11.6C13.1 0.8 14.4 1.8 14.7 3.4L17.5 18.5 24.6 0.8H30.6ZM55.3 17.2C55.3 11.2 47 10.9 47.1 8.2 47.1 7.4 47.9 6.5 49.6 6.3 50.5 6.2 52.9 6.1 55.6 7.4L56.7 2.3C55.2 1.7 53.3 1.2 51 1.2 45.4 1.2 41.5 4.2 41.4 8.5 41.4 11.7 44.3 13.5 46.5 14.6 48.8 15.7 49.5 16.4 49.5 17.4 49.5 19 47.6 19.6 45.8 19.6 42.8 19.7 41.1 18.8 39.7 18.2L38.6 23.5C40.1 24.1 42.9 24.7 45.8 24.7 51.8 24.7 55.5 21.7 55.3 17.2ZM69.8 25.2H75.2L70.4 0.8H65.1C63.8 0.8 62.7 1.6 62.2 2.8L53.5 25.2H59.5L60.7 21.9H67.9L68.9 25.2H69.8ZM62.4 17.1L65.3 9.2 67 17.1H62.4ZM38.5 0.8L33.6 25.2H27.9L32.8 0.8H38.5Z" />
        </svg>
      </div>
    );
  }

  if (b === 'MASTERCARD') {
    return (
      <div className={`${container} bg-slate-800`}>
        <svg viewBox="0 0 38 24" className="h-6 w-auto">
          <circle cx="14" cy="12" r="12" fill="#EB001B" />
          <circle cx="24" cy="12" r="12" fill="#F79E1B" />
          <path d="M19 5.3A12 12 0 0 1 23.7 12 12 12 0 0 1 19 18.7 12 12 0 0 1 14.3 12 12 12 0 0 1 19 5.3Z" fill="#FF5F00" />
        </svg>
      </div>
    );
  }

  if (b === 'AMEX') {
    return (
      <div className={`${container} bg-green-700`}>
        <span className="text-[10px] font-bold tracking-widest text-white">AMEX</span>
      </div>
    );
  }

  if (b === 'ELO') {
    return (
      <div className={`${container} bg-yellow-400`}>
        <span className="text-[11px] font-bold tracking-wider text-slate-900">ELO</span>
      </div>
    );
  }

  if (b === 'HIPERCARD') {
    return (
      <div className={`${container} bg-red-600`}>
        <span className="text-[10px] font-bold tracking-wider text-white">HIPER</span>
      </div>
    );
  }

  return (
    <div className={`${container} bg-slate-500`}>
      <span className="text-[11px] font-bold tracking-wide text-white">{brand.slice(0, 4).toUpperCase()}</span>
    </div>
  );
}
